<!-- order-list.component.html -->
<div class="container mt-5" style="max-width: 98%;">
  <!-- Search Input -->
  <div class="row justify-content-md-center">
    <div class="col-md-auto">
      <input placeholder="Search" class="search" type="text" [(ngModel)]="searchTerm" (input)="onSearch($event)" />
    </div>
  </div>


  <!-- Filter and Export -->
  <div class="row d-flex mt-3">
    <div class="d-flex col align-self-start">
      <div class="col-2">
        <app-multiselect-dropdown [options]="dropdownOptions" [title]="'Filter by order status'"
          (selectionChange)="onSelectionChange($event)"></app-multiselect-dropdown>
      </div>
    </div>
    <div class="col-1">
      <button class="btn btn-light" style="float: right;" (click)="exportList()">
        Export List
      </button>
    </div>
  </div>


  <!-- Table -->
  <div class="table-responsive mt-3">
    <label class="me-2">Show
      <select [(ngModel)]="pageSize" (change)="changePage(1)" class="form-select form-select-sm d-inline-block w-auto">
        <option [value]="5">5</option>
        <option [value]="10">10</option>
        <option [value]="25">25</option>
        <option [value]="50">50</option>
        <option [value]="100">100</option>
      </select> entries
    </label>
    <div>
      <table id="orderTable" class="table mt-4">
        <thead>
          <tr>
            <th><input type="checkbox" (change)="toggleSelectAll($event)" /></th>
            <th>Order Number</th>
              <th>Clinic</th>
            <th>Partner</th>
            <th>Partner Type</th>
            <th>Type</th>
            <th>Patient</th>
            <th>Status</th>
            <th>Created</th>
            <th>Submitted</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let order of orders; trackBy: trackByOrder">
            <td><input type="checkbox" [(ngModel)]="order.selected" /></td>
            <td>
              <a class="order-number" href="javascript:void(0)" (click)="openOrderSummary(order)">
                {{ order.orderNumber }}
              </a>
            </td>
           
              <td>{{ order.clinicId }} - {{ order.clinicName }}</td>
            
            <td>{{ order.partnerName }}</td>
            <td>{{ order.partnerType }}</td>
            <td>{{ order.type }}</td>
            <td>{{ order.patientName }}</td>
            <td>{{ order.status }}</td>
            <td>{{ order.createdAt }}</td>
            <td>{{ order.submittedAt }}</td>
            <td>
              <button *ngIf="canSubmit(order.status)" class="btn btn-sm btn-light" (click)="confirmSubmit(order)">
                Submit
              </button>
              <button *ngIf="canEdit(order.status)" class="btn btn-sm btn-light" (click)="editOrder(order)">
                Edit
              </button>
              <button *ngIf="canDuplicate(order.status)" class="btn btn-sm btn-light" (click)="duplicateOrder(order)">
                Duplicate
              </button>
              <button *ngIf="canCancel(order.status)" class="btn btn-sm btn-light"
                (click)="cancelOrder(order, cancelModal)">
                Cancel
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

  </div>

  <!-- Pagination Controls -->
  <div class="row mt-4">
    <div class="col-sm-12 col-md-6 d-flex align-items-center">
      <span>
        Showing {{ getRecordStart() }} to {{ getRecordEnd() }} of {{ totalRows }} entries
      </span>
    </div>
    <div class="col-sm-12 col-md-6 text-end">
      <nav>
        <ul class="pagination pagination-sm justify-content-end mb-0">
          <li class="page-item" [class.disabled]="pageNumber === 1">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(pageNumber - 1)" tabindex="-1">Previous</a>
          </li>
          <li
            class="page-item"
            *ngFor="let p of getPageNumbers()"
            [class.active]="p === pageNumber">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(p)">{{ p }}</a>
          </li>
          <li class="page-item" [class.disabled]="pageNumber === totalPages">
            <a class="page-link" href="javascript:void(0)" (click)="changePage(pageNumber + 1)">Next</a>
          </li>
        </ul>
      </nav>
    </div>
  </div>
</div>

<!-- Cancel Order Modal -->
<ng-template #cancelModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-basic-title">Confirm Cancellation</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissCancel()"></button>
  </div>
  <div class="modal-body" style="text-align: center;">
    Are you sure you want to cancel order <br> <strong>{{ selectedOrder?.orderNumber }}</strong>?
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary btn-cancel-order-no" (click)="dismissCancel()">No</button>
    <button type="button" class="btn btn-danger btn-cancel-order-yes" (click)="confirmCancel()">Yes, Cancel
      Order</button>
  </div>
</ng-template>

<!-- Order Summary Modal -->
<ng-template #orderSummaryModal let-modal>
  <div class="modal-header">
    <h5 class="modal-title" id="modal-order-summary-title">Order Summary - {{ selectedOrder?.orderNumber }}</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="dismissOrderSummary()"></button>
  </div>
  <div class="modal-body" style="height: 80vh;">
    <iframe [src]="orderSummaryUrl" width="100%" height="100%" frameborder="0"></iframe>
  </div>
  <div class="modal-footer">
    <button *ngIf="selectedOrder?.status === STATUS.QUOTED" type="button" [disabled]="isLoading" class="btn btn-secondary btn-quote"
      (click)="downloadQuotation()">
      Quote
    </button>
    <button type="button" class="btn btn-secondary" (click)="dismissOrderSummary()">Close</button>
  </div>
</ng-template>

<!-- Loading Overlay -->
<div *ngIf="isLoading" class="loading-overlay">
  <div class="spinner-border text-primary" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>